import { o as o_util } from "../chunks/common-namespaces-client-DXKc2YAH.mjs";
import { o as otto } from "../chunks/common-nexus-client-CLQM3FGj.mjs";
const apm = otto.apm ?? {};
const agent = apm.agent;
const getCurrentTransaction = apm.getCurrentTransaction;
const startSpan = apm.startSpan;
const captureError = apm.captureError;
const mark = apm.mark;
const addLabels = apm.addLabels;
const sendCustomError = apm.sendCustomError;
const apmSync = o_util.apm ?? {};
const runWithSpan = apmSync.runWithSpan;
const withSpan = apmSync.withSpan;
export {
  addLabels,
  agent,
  apm,
  apmSync,
  captureError,
  getCurrentTransaction,
  mark,
  runWithSpan,
  sendCustomError,
  startSpan,
  withSpan
};
/*                                   */
